module.exports = __webpack_public_path__ + "assets/img/water-1.921baa7c.jpeg";